import {
  AUTH_USER_DATA_FAIL,
  AUTH_USER_DATA_REQUEST,
  AUTH_USER_DATA_RESET,
  AUTH_USER_DATA_SUCCESS,
} from "../constants/userAuthConstants";

export const authmodul_user_data_reducers = (state = { data: {} }, action) => {
  switch (action.type) {
    case AUTH_USER_DATA_REQUEST:
      return { loading: true };
    case AUTH_USER_DATA_SUCCESS:
      return { loading: false, data: action.payload, success: true };
    case AUTH_USER_DATA_FAIL:
      return { loading: false, error: action.payload };
    case AUTH_USER_DATA_RESET:
      return {};
    default:
      return state;
  }
};
